<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Edit Contact
      </h1>
      <br>
      <p class="subheader-style">
        Please edit your emergency contact details here.
      </p>
      <v-card
        color="#E2E2E2"
        elevation="0"
      >
        <v-card-title>
          <p class="process-header">
            Emergency Contact
          </p>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-text-field
              v-model="name"
              label="Enter Name*"
              dense
              :rules="[(v) => !!v || 'This field is required']"
              filled
              color="#000000"
              light
              outlined
            />
            <v-text-field
              v-model="phoneNumber"
              type="number"
              label="Enter Number*"
              dense
              :rules="phoneNumberRules"
              filled
              color="#000000"
              light
              outlined
            />
            <v-text-field
              v-model="relation"
              label="Enter Your Relation*"
              dense
              :rules="[(v) => !!v || 'This field is required']"
              filled
              color="#000000"
              light
              outlined
            />
          </v-form>
        </v-card-text>
      </v-card>
      <br>
      <v-btn
        class="btn-style"
        color="#37474F"
        elevation="0"
        @click="addEmergencyContact()"
      >
        Update
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="showModal = false"
      >
        Cancel
      </v-btn>
      <center-spinner :loading="loading" />
    </div>
  </v-dialog>
</template>

<script>
import spinner from '../../../components/SpinnerCentre.vue';
import Constants from 'src/constants';

export default {
  name: 'EditEmergencyContact',
  components: {
    'center-spinner': spinner,
  },
  props: {
    editData: {
      type: Object,
      default: null,
    },
    selectedIndex: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    showModal: true,
    valid: false,
    name: '',
    phoneNumber: '',
    relation: '',
    emergencyContactData: [],
  }),
  computed: {
    phoneNumberRules () {
      return [
        (v) => !!v || 'This field is required',
        (v) => (v && v.length <= 15) || 'Phone number exceeded the limit.',
      ];
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    await this.loadOnMount();
  },
  methods: {
    addEmergencyContact () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.emergencyContactData = this.editData.emergency_contact;
      this.emergencyContactData.splice(this.selectedIndex, 1);
      const data =
      {
        name: this.name,
        phone_number: this.phoneNumber,
        relation: this.relation,

      };
      this.emergencyContactData.unshift(data);

      this.$store.dispatch('userprofile/updateUserDetails', {
        details: {
          first_name: this.editData.first_name,
          last_name: this.editData.last_name,
          emergency_contact: this.emergencyContactData,
        },

      }).then(() => {
        this.$store.dispatch('alert/onAlert', {
          message: 'Emergency contact Updated successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.loading = false;
        this.showModal = false;
      }).catch(errors => {
        this.loading = false;
      });
    },
    loadOnMount () {
      this.name = this.editData.emergency_contact[this.selectedIndex].name;
      this.phoneNumber = this.editData.emergency_contact[this.selectedIndex].phone_number;
      this.relation = this.editData.emergency_contact[this.selectedIndex].relation;
    },
  },
};
</script>

<style scoped>
.content-section {
  height: 100vh;
}
</style>
